module.exports = __webpack_public_path__ + "img/foobtn.b3e5fc41.svg";